import { render, staticRenderFns } from "./ManageDashboardDialog.vue?vue&type=template&id=33a49f53&scoped=true"
import script from "./ManageDashboardDialog.vue?vue&type=script&lang=js"
export * from "./ManageDashboardDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageDashboardDialog.vue?vue&type=style&index=0&id=33a49f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a49f53",
  null
  
)

export default component.exports